"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.DedicationInfo = exports.FEOrderLineItemOutputModel = exports.OrderPaymentMethod = exports.DedicationInfoInputModel = exports.ExternnalPaymentUrlOutputModel = exports.FEOrderSummaryOutputModel = exports.UploadedImageFileOutputModel = exports.HelpRequestInputModel = exports.HelpRequestFieldInputModel = exports.DedicationDesignOutputModel = exports.FEHelpRequestFormOutputModel = exports.FEHelpRequestFormFieldOutputModel = exports.FEHelpRequestFormFieldOptionOutputModel = exports.HelpRequestFormFieldType = exports.FEBannerOutputModel = exports.FEBannerItemOutputModel = exports.BannerItemDestinationType = exports.FEPagedItemsOutputModel = exports.PagedMetadata = exports.FEItemOutputModel = exports.FEItemImageOutputModel = exports.FESuggestedAmountOutputModel = exports.VariationOption = exports.ItemStatus = exports.PagedItemFilterInputModel = exports.SortBy = exports.FEAllCategoriesOutputModel = exports.FECategoryOutputModel = exports.UpdateCartItemQuantityInputModel = exports.RemoveCartItemInputModel = exports.AddCartItemInputModel = exports.FECartOutputModel = exports.FECartLineItem = exports.ItemPaymentType = exports.ItemType = exports.LocalizedStringOutputModel = exports.ResetPasswordInputModel = exports.FECustomerOutputModel = exports.UpdateCustomerInfoInputModel = exports.ChangePasswordInputModel = exports.LogInInputModel = exports.ProblemDetails = exports.BearerTokenOutputModel = exports.SignUpInputModel = exports.SubscriptionClient = exports.OrderClient = exports.HelpClient = exports.CatalogClient = exports.CartClient = exports.AccountClient = void 0;
exports.ApiException = exports.AddMultipleInstallmentsInputModel = exports.FEUnpaidSubscriptionInstallmentOutputModel = exports.FESubscriptionInvoiceOutputModel = exports.FESubscriptionInvoiceInstallmentOutputModel = exports.UpdateSubscriptionInputModel = exports.SubscribeToItemInputModel = exports.FESubscriptionLookupOutputModel = exports.FESubscriptionOutputModel = exports.FESubscriptionInstallmentOutputModel = exports.SubscriptionStatus = exports.CreateInvoiceInputModel = exports.FESubscriptionInvoiceSummaryOutputModel = exports.FEOrderOutputModel = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = require("axios");
var AccountClient = /** @class */ (function () {
    function AccountClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1["default"].create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    AccountClient.prototype.signUp = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/SignUp";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignUp(_response);
        });
    };
    AccountClient.prototype.processSignUp = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BearerTokenOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountClient.prototype.logIn = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/LogIn";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLogIn(_response);
        });
    };
    AccountClient.prototype.processLogIn = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BearerTokenOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    AccountClient.prototype.signUpAnonymous = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/SignUpAnonymous";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSignUpAnonymous(_response);
        });
    };
    AccountClient.prototype.processSignUpAnonymous = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = BearerTokenOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountClient.prototype.changePassword = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangePassword(_response);
        });
    };
    AccountClient.prototype.processChangePassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param email (optional)
     * @param language (optional)
     * @return Success
     */
    AccountClient.prototype.forgotPassword = function (email, language, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ForgotPassword?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (language !== undefined && language !== null)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processForgotPassword(_response);
        });
    };
    AccountClient.prototype.processForgotPassword = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountClient.prototype.updateCustomerInfo = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/UpdateCustomerInfo";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateCustomerInfo(_response);
        });
    };
    AccountClient.prototype.processUpdateCustomerInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    AccountClient.prototype.customerInfo = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/CustomerInfo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCustomerInfo(_response);
        });
    };
    AccountClient.prototype.processCustomerInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FECustomerOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    AccountClient.prototype.confirmReset = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Account/ConfirmReset";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConfirmReset(_response);
        });
    };
    AccountClient.prototype.processConfirmReset = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AccountClient;
}());
exports.AccountClient = AccountClient;
var CartClient = /** @class */ (function () {
    function CartClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1["default"].create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @return Success
     */
    CartClient.prototype.cart = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Cart/Cart";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCart(_response);
        });
    };
    CartClient.prototype.processCart = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FECartOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CartClient.prototype.addItem = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Cart/AddItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddItem(_response);
        });
    };
    CartClient.prototype.processAddItem = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CartClient.prototype.removeItem = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Cart/RemoveItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveItem(_response);
        });
    };
    CartClient.prototype.processRemoveItem = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CartClient.prototype.updateQuantity = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Cart/UpdateQuantity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateQuantity(_response);
        });
    };
    CartClient.prototype.processUpdateQuantity = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CartClient;
}());
exports.CartClient = CartClient;
var CatalogClient = /** @class */ (function () {
    function CatalogClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1["default"].create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @return Success
     */
    CatalogClient.prototype.categories = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/Categories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories(_response);
        });
    };
    CatalogClient.prototype.processCategories = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                    var item = resultData200_1[_i];
                    result200.push(FECategoryOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CatalogClient.prototype.allCategories = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/AllCategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllCategories(_response);
        });
    };
    CatalogClient.prototype.processAllCategories = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEAllCategoriesOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CatalogClient.prototype.pagedItems = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/PagedItems";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPagedItems(_response);
        });
    };
    CatalogClient.prototype.processPagedItems = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEPagedItemsOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CatalogClient.prototype.testPagedItems = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/TestPagedItems";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTestPagedItems(_response);
        });
    };
    CatalogClient.prototype.processTestPagedItems = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEPagedItemsOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param outlineId (optional)
     * @return Success
     */
    CatalogClient.prototype.getItemByOutlineId = function (outlineId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/GetItemByOutlineId?";
        if (outlineId !== undefined && outlineId !== null)
            url_ += "outlineId=" + encodeURIComponent("" + outlineId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetItemByOutlineId(_response);
        });
    };
    CatalogClient.prototype.processGetItemByOutlineId = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEItemOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param itemId (optional)
     * @return Success
     */
    CatalogClient.prototype.getItem = function (itemId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/GetItem?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetItem(_response);
        });
    };
    CatalogClient.prototype.processGetItem = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEItemOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CatalogClient.prototype.search = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/Search";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearch(_response);
        });
    };
    CatalogClient.prototype.processSearch = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEPagedItemsOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CatalogClient.prototype.homeBanner = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/HomeBanner";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHomeBanner(_response);
        });
    };
    CatalogClient.prototype.processHomeBanner = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEBannerOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CatalogClient.prototype.homePageItems = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/HomePageItems";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHomePageItems(_response);
        });
    };
    CatalogClient.prototype.processHomePageItems = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                    var item = resultData200_2[_i];
                    result200.push(FEItemOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CatalogClient.prototype.helpRequestForms = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/HelpRequestForms";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHelpRequestForms(_response);
        });
    };
    CatalogClient.prototype.processHelpRequestForms = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                    var item = resultData200_3[_i];
                    result200.push(FEHelpRequestFormOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CatalogClient.prototype.helpRequestFormById = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/HelpRequestFormById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHelpRequestFormById(_response);
        });
    };
    CatalogClient.prototype.processHelpRequestFormById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEHelpRequestFormOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param id (optional)
     * @param key (optional)
     * @return Success
     */
    CatalogClient.prototype.privateHelpRequestFormById = function (id, key, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/PrivateHelpRequestFormById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPrivateHelpRequestFormById(_response);
        });
    };
    CatalogClient.prototype.processPrivateHelpRequestFormById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEHelpRequestFormOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param key (optional)
     * @return Success
     */
    CatalogClient.prototype.privateHelpRequestFormByKey = function (key, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/PrivateHelpRequestFormByKey?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPrivateHelpRequestFormByKey(_response);
        });
    };
    CatalogClient.prototype.processPrivateHelpRequestFormByKey = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEHelpRequestFormOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CatalogClient.prototype.dedicationDesigns = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/DedicationDesigns";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDedicationDesigns(_response);
        });
    };
    CatalogClient.prototype.processDedicationDesigns = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                    var item = resultData200_4[_i];
                    result200.push(DedicationDesignOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CatalogClient.prototype.subscriptionItems = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Catalog/SubscriptionItems";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscriptionItems(_response);
        });
    };
    CatalogClient.prototype.processSubscriptionItems = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                    var item = resultData200_5[_i];
                    result200.push(FEItemOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return CatalogClient;
}());
exports.CatalogClient = CatalogClient;
var HelpClient = /** @class */ (function () {
    function HelpClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1["default"].create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    HelpClient.prototype.createHelpRequest = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Help/CreateHelpRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateHelpRequest(_response);
        });
    };
    HelpClient.prototype.processCreateHelpRequest = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    HelpClient.prototype.createPrivateHelpRequest = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Help/CreatePrivateHelpRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreatePrivateHelpRequest(_response);
        });
    };
    HelpClient.prototype.processCreatePrivateHelpRequest = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param contentType (optional)
     * @param contentDisposition (optional)
     * @param headers (optional)
     * @param length (optional)
     * @param name (optional)
     * @param fileName (optional)
     * @return Success
     */
    HelpClient.prototype.upload = function (contentType, contentDisposition, headers, length, name, fileName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Help/upload";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpload(_response);
        });
    };
    HelpClient.prototype.processUpload = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = UploadedImageFileOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return HelpClient;
}());
exports.HelpClient = HelpClient;
var OrderClient = /** @class */ (function () {
    function OrderClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1["default"].create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param trandata (optional)
     * @param errorText (optional)
     * @return Success
     */
    OrderClient.prototype.knetexternalpaymentcallback = function (trandata, errorText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/knetexternalpaymentcallback";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (trandata !== null && trandata !== undefined)
            content_.append("trandata", trandata.toString());
        if (errorText !== null && errorText !== undefined)
            content_.append("ErrorText", errorText.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processKnetexternalpaymentcallback(_response);
        });
    };
    OrderClient.prototype.processKnetexternalpaymentcallback = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param trandata (optional)
     * @param errorText (optional)
     * @return Success
     */
    OrderClient.prototype.knetexternalpaymentcallbackTest = function (trandata, errorText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/knetexternalpaymentcallbackTest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (trandata !== null && trandata !== undefined)
            content_.append("trandata", trandata.toString());
        if (errorText !== null && errorText !== undefined)
            content_.append("ErrorText", errorText.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processKnetexternalpaymentcallbackTest(_response);
        });
    };
    OrderClient.prototype.processKnetexternalpaymentcallbackTest = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param number (optional)
     * @return Success
     */
    OrderClient.prototype.orderSummaryByNumber = function (number, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/OrderSummaryByNumber?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOrderSummaryByNumber(_response);
        });
    };
    OrderClient.prototype.processOrderSummaryByNumber = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEOrderSummaryOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param number (optional)
     * @param paymentId (optional)
     * @param transactionId (optional)
     * @return Success
     */
    OrderClient.prototype.orderSummaryByPaymentInfo = function (number, paymentId, transactionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/OrderSummaryByPaymentInfo?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (paymentId !== undefined && paymentId !== null)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOrderSummaryByPaymentInfo(_response);
        });
    };
    OrderClient.prototype.processOrderSummaryByPaymentInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEOrderSummaryOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    OrderClient.prototype.createOrder = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateOrder(_response);
        });
    };
    OrderClient.prototype.processCreateOrder = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ExternnalPaymentUrlOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderClient.prototype.createOrderWithDedication = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/CreateOrderWithDedication";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateOrderWithDedication(_response);
        });
    };
    OrderClient.prototype.processCreateOrderWithDedication = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ExternnalPaymentUrlOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    OrderClient.prototype.customerOrders = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/CustomerOrders";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCustomerOrders(_response);
        });
    };
    OrderClient.prototype.processCustomerOrders = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                    var item = resultData200_6[_i];
                    result200.push(FEOrderOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderClient.prototype.orderDetailById = function (orderId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/OrderDetailById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOrderDetailById(_response);
        });
    };
    OrderClient.prototype.processOrderDetailById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEOrderOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param number (optional)
     * @param paymentId (optional)
     * @param transactionId (optional)
     * @return Success
     */
    OrderClient.prototype.orderDetailByPaymentInfo = function (number, paymentId, transactionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Order/OrderDetailByPaymentInfo?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (paymentId !== undefined && paymentId !== null)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOrderDetailByPaymentInfo(_response);
        });
    };
    OrderClient.prototype.processOrderDetailByPaymentInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FEOrderOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return OrderClient;
}());
exports.OrderClient = OrderClient;
var SubscriptionClient = /** @class */ (function () {
    function SubscriptionClient(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1["default"].create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "";
    }
    /**
     * @param trandata (optional)
     * @param errorText (optional)
     * @return Success
     */
    SubscriptionClient.prototype.knetexternalpaymentcallback = function (trandata, errorText, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/knetexternalpaymentcallback";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (trandata !== null && trandata !== undefined)
            content_.append("trandata", trandata.toString());
        if (errorText !== null && errorText !== undefined)
            content_.append("ErrorText", errorText.toString());
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processKnetexternalpaymentcallback(_response);
        });
    };
    SubscriptionClient.prototype.processKnetexternalpaymentcallback = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param number (optional)
     * @return Success
     */
    SubscriptionClient.prototype.invoiceSummaryByNumber = function (number, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/InvoiceSummaryByNumber?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInvoiceSummaryByNumber(_response);
        });
    };
    SubscriptionClient.prototype.processInvoiceSummaryByNumber = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FESubscriptionInvoiceSummaryOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param number (optional)
     * @param paymentId (optional)
     * @param transactionId (optional)
     * @return Success
     */
    SubscriptionClient.prototype.invoiceSummaryByPaymentInfo = function (number, paymentId, transactionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/InvoiceSummaryByPaymentInfo?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (paymentId !== undefined && paymentId !== null)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInvoiceSummaryByPaymentInfo(_response);
        });
    };
    SubscriptionClient.prototype.processInvoiceSummaryByPaymentInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FESubscriptionInvoiceSummaryOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SubscriptionClient.prototype.createInvoice = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateInvoice(_response);
        });
    };
    SubscriptionClient.prototype.processCreateInvoice = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = ExternnalPaymentUrlOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SubscriptionClient.prototype.customerSubscriptions = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/CustomerSubscriptions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCustomerSubscriptions(_response);
        });
    };
    SubscriptionClient.prototype.processCustomerSubscriptions = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                    var item = resultData200_7[_i];
                    result200.push(FESubscriptionOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SubscriptionClient.prototype.customerActiveSubscriptions = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/CustomerActiveSubscriptions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCustomerActiveSubscriptions(_response);
        });
    };
    SubscriptionClient.prototype.processCustomerActiveSubscriptions = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                    var item = resultData200_8[_i];
                    result200.push(FESubscriptionOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SubscriptionClient.prototype.customerCanceledSubscriptions = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/CustomerCanceledSubscriptions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCustomerCanceledSubscriptions(_response);
        });
    };
    SubscriptionClient.prototype.processCustomerCanceledSubscriptions = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                    var item = resultData200_9[_i];
                    result200.push(FESubscriptionOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param subscriptionId (optional)
     * @return Success
     */
    SubscriptionClient.prototype.subscriptionDetailById = function (subscriptionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/SubscriptionDetailById?";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscriptionDetailById(_response);
        });
    };
    SubscriptionClient.prototype.processSubscriptionDetailById = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FESubscriptionOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SubscriptionClient.prototype.subscriptionLookup = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/SubscriptionLookup";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscriptionLookup(_response);
        });
    };
    SubscriptionClient.prototype.processSubscriptionLookup = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FESubscriptionLookupOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SubscriptionClient.prototype.subscribeToItem = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/SubscribeToItem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubscribeToItem(_response);
        });
    };
    SubscriptionClient.prototype.processSubscribeToItem = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SubscriptionClient.prototype.updateSubscription = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateSubscription(_response);
        });
    };
    SubscriptionClient.prototype.processUpdateSubscription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param number (optional)
     * @param paymentId (optional)
     * @param transactionId (optional)
     * @return Success
     */
    SubscriptionClient.prototype.invoiceDetailByPaymentInfo = function (number, paymentId, transactionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/InvoiceDetailByPaymentInfo?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (paymentId !== undefined && paymentId !== null)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInvoiceDetailByPaymentInfo(_response);
        });
    };
    SubscriptionClient.prototype.processInvoiceDetailByPaymentInfo = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = FESubscriptionInvoiceOutputModel.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    SubscriptionClient.prototype.unpaidInstallments = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/UnpaidInstallments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnpaidInstallments(_response);
        });
    };
    SubscriptionClient.prototype.processUnpaidInstallments = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                    var item = resultData200_10[_i];
                    result200.push(FEUnpaidSubscriptionInstallmentOutputModel.fromJS(item));
                }
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SubscriptionClient.prototype.addMultipleInstallments = function (body, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/AddMultipleInstallments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddMultipleInstallments(_response);
        });
    };
    SubscriptionClient.prototype.processAddMultipleInstallments = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * @param subscriptionId (optional)
     * @return Success
     */
    SubscriptionClient.prototype.cancelSubscription = function (subscriptionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/Subscription/CancelSubscription?";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken: cancelToken
        };
        return this.instance.request(options_)["catch"](function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCancelSubscription(_response);
        });
    };
    SubscriptionClient.prototype.processCancelSubscription = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            var _responseText = response.data;
            var result400 = null;
            var resultData400 = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 500) {
            var _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return SubscriptionClient;
}());
exports.SubscriptionClient = SubscriptionClient;
var SignUpInputModel = /** @class */ (function () {
    function SignUpInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SignUpInputModel.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.countryCode = _data["countryCode"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    };
    SignUpInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SignUpInputModel();
        result.init(data);
        return result;
    };
    SignUpInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["countryCode"] = this.countryCode;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    };
    return SignUpInputModel;
}());
exports.SignUpInputModel = SignUpInputModel;
var BearerTokenOutputModel = /** @class */ (function () {
    function BearerTokenOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BearerTokenOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.isRegistered = _data["isRegistered"];
            this.token = _data["token"];
        }
    };
    BearerTokenOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BearerTokenOutputModel();
        result.init(data);
        return result;
    };
    BearerTokenOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isRegistered"] = this.isRegistered;
        data["token"] = this.token;
        return data;
    };
    return BearerTokenOutputModel;
}());
exports.BearerTokenOutputModel = BearerTokenOutputModel;
var ProblemDetails = /** @class */ (function () {
    function ProblemDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProblemDetails.prototype.init = function (_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {};
                for (var key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key];
                }
            }
        }
    };
    ProblemDetails.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProblemDetails();
        result.init(data);
        return result;
    };
    ProblemDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (var key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    };
    return ProblemDetails;
}());
exports.ProblemDetails = ProblemDetails;
var LogInInputModel = /** @class */ (function () {
    function LogInInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogInInputModel.prototype.init = function (_data) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    };
    LogInInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogInInputModel();
        result.init(data);
        return result;
    };
    LogInInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    };
    return LogInInputModel;
}());
exports.LogInInputModel = LogInInputModel;
var ChangePasswordInputModel = /** @class */ (function () {
    function ChangePasswordInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordInputModel.prototype.init = function (_data) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.language = _data["language"];
        }
    };
    ChangePasswordInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangePasswordInputModel();
        result.init(data);
        return result;
    };
    ChangePasswordInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["language"] = this.language;
        return data;
    };
    return ChangePasswordInputModel;
}());
exports.ChangePasswordInputModel = ChangePasswordInputModel;
var UpdateCustomerInfoInputModel = /** @class */ (function () {
    function UpdateCustomerInfoInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCustomerInfoInputModel.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.language = _data["language"];
            this.phone = _data["phone"];
        }
    };
    UpdateCustomerInfoInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCustomerInfoInputModel();
        result.init(data);
        return result;
    };
    UpdateCustomerInfoInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["language"] = this.language;
        data["phone"] = this.phone;
        return data;
    };
    return UpdateCustomerInfoInputModel;
}());
exports.UpdateCustomerInfoInputModel = UpdateCustomerInfoInputModel;
var FECustomerOutputModel = /** @class */ (function () {
    function FECustomerOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FECustomerOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.userId = _data["userId"];
            this.isRegistered = _data["isRegistered"];
            this.language = _data["language"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FECustomerOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FECustomerOutputModel();
        result.init(data);
        return result;
    };
    FECustomerOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["userId"] = this.userId;
        data["isRegistered"] = this.isRegistered;
        data["language"] = this.language;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FECustomerOutputModel;
}());
exports.FECustomerOutputModel = FECustomerOutputModel;
var ResetPasswordInputModel = /** @class */ (function () {
    function ResetPasswordInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordInputModel.prototype.init = function (_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    };
    ResetPasswordInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordInputModel();
        result.init(data);
        return result;
    };
    ResetPasswordInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    };
    return ResetPasswordInputModel;
}());
exports.ResetPasswordInputModel = ResetPasswordInputModel;
var LocalizedStringOutputModel = /** @class */ (function () {
    function LocalizedStringOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizedStringOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.english = _data["english"];
            this.arabic = _data["arabic"];
        }
    };
    LocalizedStringOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizedStringOutputModel();
        result.init(data);
        return result;
    };
    LocalizedStringOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["english"] = this.english;
        data["arabic"] = this.arabic;
        return data;
    };
    return LocalizedStringOutputModel;
}());
exports.LocalizedStringOutputModel = LocalizedStringOutputModel;
var ItemType;
(function (ItemType) {
    ItemType["OpenDonation"] = "OpenDonation";
    ItemType["TargetCostDonation"] = "TargetCostDonation";
    ItemType["Subscription"] = "Subscription";
    ItemType["InfoOnly"] = "InfoOnly";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var ItemPaymentType;
(function (ItemPaymentType) {
    ItemPaymentType["UserInputAmount"] = "UserInputAmount";
    ItemPaymentType["FixedAmount"] = "FixedAmount";
    ItemPaymentType["UserInputAmountWithFixedOptions"] = "UserInputAmountWithFixedOptions";
})(ItemPaymentType = exports.ItemPaymentType || (exports.ItemPaymentType = {}));
var FECartLineItem = /** @class */ (function () {
    function FECartLineItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FECartLineItem.prototype.init = function (_data) {
        if (_data) {
            this.originalItemId = _data["originalItemId"];
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.variationOptionDispalyText = _data["variationOptionDispalyText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionDispalyText"]) : undefined;
            this.barcode = _data["barcode"];
            this.type = _data["type"];
            this.paymentType = _data["paymentType"];
            this.fixedDonationAmount = _data["fixedDonationAmount"];
            this.quantity = _data["quantity"];
            this.paidAmount = _data["paidAmount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FECartLineItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FECartLineItem();
        result.init(data);
        return result;
    };
    FECartLineItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["originalItemId"] = this.originalItemId;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["variationOptionDispalyText"] = this.variationOptionDispalyText ? this.variationOptionDispalyText.toJSON() : undefined;
        data["barcode"] = this.barcode;
        data["type"] = this.type;
        data["paymentType"] = this.paymentType;
        data["fixedDonationAmount"] = this.fixedDonationAmount;
        data["quantity"] = this.quantity;
        data["paidAmount"] = this.paidAmount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FECartLineItem;
}());
exports.FECartLineItem = FECartLineItem;
var FECartOutputModel = /** @class */ (function () {
    function FECartOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FECartOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [];
                for (var _i = 0, _a = _data["lineItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.lineItems.push(FECartLineItem.fromJS(item));
                }
            }
            this.total = _data["total"];
            this.lastSync = _data["lastSync"] ? new Date(_data["lastSync"].toString()) : undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FECartOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FECartOutputModel();
        result.init(data);
        return result;
    };
    FECartOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (var _i = 0, _a = this.lineItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["lineItems"].push(item ? item.toJSON() : undefined);
            }
        }
        data["total"] = this.total;
        data["lastSync"] = this.lastSync ? this.lastSync.toISOString() : undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FECartOutputModel;
}());
exports.FECartOutputModel = FECartOutputModel;
var AddCartItemInputModel = /** @class */ (function () {
    function AddCartItemInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddCartItemInputModel.prototype.init = function (_data) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.quantity = _data["quantity"];
            this.itemId = _data["itemId"];
            this.amount = _data["amount"];
            this.language = _data["language"];
        }
    };
    AddCartItemInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddCartItemInputModel();
        result.init(data);
        return result;
    };
    AddCartItemInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["quantity"] = this.quantity;
        data["itemId"] = this.itemId;
        data["amount"] = this.amount;
        data["language"] = this.language;
        return data;
    };
    return AddCartItemInputModel;
}());
exports.AddCartItemInputModel = AddCartItemInputModel;
var RemoveCartItemInputModel = /** @class */ (function () {
    function RemoveCartItemInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RemoveCartItemInputModel.prototype.init = function (_data) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.lineItemId = _data["lineItemId"];
            this.language = _data["language"];
        }
    };
    RemoveCartItemInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RemoveCartItemInputModel();
        result.init(data);
        return result;
    };
    RemoveCartItemInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["lineItemId"] = this.lineItemId;
        data["language"] = this.language;
        return data;
    };
    return RemoveCartItemInputModel;
}());
exports.RemoveCartItemInputModel = RemoveCartItemInputModel;
var UpdateCartItemQuantityInputModel = /** @class */ (function () {
    function UpdateCartItemQuantityInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateCartItemQuantityInputModel.prototype.init = function (_data) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.lineItemId = _data["lineItemId"];
            this.language = _data["language"];
            this.quantity = _data["quantity"];
        }
    };
    UpdateCartItemQuantityInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateCartItemQuantityInputModel();
        result.init(data);
        return result;
    };
    UpdateCartItemQuantityInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["lineItemId"] = this.lineItemId;
        data["language"] = this.language;
        data["quantity"] = this.quantity;
        return data;
    };
    return UpdateCartItemQuantityInputModel;
}());
exports.UpdateCartItemQuantityInputModel = UpdateCartItemQuantityInputModel;
var FECategoryOutputModel = /** @class */ (function () {
    function FECategoryOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FECategoryOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.description = _data["description"] ? LocalizedStringOutputModel.fromJS(_data["description"]) : undefined;
            this.outlineId = _data["outlineId"];
            this.outline = _data["outline"];
            this.path = _data["path"];
            this.childrenCategoriesOutline = _data["childrenCategoriesOutline"];
            this.parentCategoryId = _data["parentCategoryId"];
            this.imageUrl = _data["imageUrl"] ? LocalizedStringOutputModel.fromJS(_data["imageUrl"]) : undefined;
            this.sortOrder = _data["sortOrder"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["subCategories"])) {
                this.subCategories = [];
                for (var _i = 0, _a = _data["subCategories"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.subCategories.push(FECategoryOutputModel.fromJS(item));
                }
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FECategoryOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FECategoryOutputModel();
        result.init(data);
        return result;
    };
    FECategoryOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["outlineId"] = this.outlineId;
        data["outline"] = this.outline;
        data["path"] = this.path;
        data["childrenCategoriesOutline"] = this.childrenCategoriesOutline;
        data["parentCategoryId"] = this.parentCategoryId;
        data["imageUrl"] = this.imageUrl ? this.imageUrl.toJSON() : undefined;
        data["sortOrder"] = this.sortOrder;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.subCategories)) {
            data["subCategories"] = [];
            for (var _i = 0, _a = this.subCategories; _i < _a.length; _i++) {
                var item = _a[_i];
                data["subCategories"].push(item ? item.toJSON() : undefined);
            }
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FECategoryOutputModel;
}());
exports.FECategoryOutputModel = FECategoryOutputModel;
var FEAllCategoriesOutputModel = /** @class */ (function () {
    function FEAllCategoriesOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEAllCategoriesOutputModel.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["flatCategories"])) {
                this.flatCategories = [];
                for (var _i = 0, _a = _data["flatCategories"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.flatCategories.push(FECategoryOutputModel.fromJS(item));
                }
            }
            if (Array.isArray(_data["categoryTree"])) {
                this.categoryTree = [];
                for (var _b = 0, _c = _data["categoryTree"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.categoryTree.push(FECategoryOutputModel.fromJS(item));
                }
            }
        }
    };
    FEAllCategoriesOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEAllCategoriesOutputModel();
        result.init(data);
        return result;
    };
    FEAllCategoriesOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flatCategories)) {
            data["flatCategories"] = [];
            for (var _i = 0, _a = this.flatCategories; _i < _a.length; _i++) {
                var item = _a[_i];
                data["flatCategories"].push(item ? item.toJSON() : undefined);
            }
        }
        if (Array.isArray(this.categoryTree)) {
            data["categoryTree"] = [];
            for (var _b = 0, _c = this.categoryTree; _b < _c.length; _b++) {
                var item = _c[_b];
                data["categoryTree"].push(item ? item.toJSON() : undefined);
            }
        }
        return data;
    };
    return FEAllCategoriesOutputModel;
}());
exports.FEAllCategoriesOutputModel = FEAllCategoriesOutputModel;
var SortBy;
(function (SortBy) {
    SortBy["SortOrderAscending"] = "SortOrderAscending";
    SortBy["SortOrderDescending"] = "SortOrderDescending";
    SortBy["CostAscending"] = "CostAscending";
    SortBy["CostDescending"] = "CostDescending";
    SortBy["CreatedAtAscending"] = "CreatedAtAscending";
    SortBy["CreatedAtDescending"] = "CreatedAtDescending";
    SortBy["UncompletedFirst"] = "UncompletedFirst";
})(SortBy = exports.SortBy || (exports.SortBy = {}));
var PagedItemFilterInputModel = /** @class */ (function () {
    function PagedItemFilterInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedItemFilterInputModel.prototype.init = function (_data) {
        if (_data) {
            this.categoryOutlineId = _data["categoryOutlineId"];
            this.sortBy = _data["sortBy"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.searchText = _data["searchText"];
        }
    };
    PagedItemFilterInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedItemFilterInputModel();
        result.init(data);
        return result;
    };
    PagedItemFilterInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["categoryOutlineId"] = this.categoryOutlineId;
        data["sortBy"] = this.sortBy;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["searchText"] = this.searchText;
        return data;
    };
    return PagedItemFilterInputModel;
}());
exports.PagedItemFilterInputModel = PagedItemFilterInputModel;
var ItemStatus;
(function (ItemStatus) {
    ItemStatus["None"] = "None";
    ItemStatus["NotCompleted"] = "NotCompleted";
    ItemStatus["Completed"] = "Completed";
    ItemStatus["OpenCompleted"] = "OpenCompleted";
})(ItemStatus = exports.ItemStatus || (exports.ItemStatus = {}));
var VariationOption;
(function (VariationOption) {
    VariationOption["None"] = "None";
    VariationOption["Dropdown"] = "Dropdown";
    VariationOption["Radio"] = "Radio";
})(VariationOption = exports.VariationOption || (exports.VariationOption = {}));
var FESuggestedAmountOutputModel = /** @class */ (function () {
    function FESuggestedAmountOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESuggestedAmountOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.amount = _data["amount"];
        }
    };
    FESuggestedAmountOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESuggestedAmountOutputModel();
        result.init(data);
        return result;
    };
    FESuggestedAmountOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    };
    return FESuggestedAmountOutputModel;
}());
exports.FESuggestedAmountOutputModel = FESuggestedAmountOutputModel;
var FEItemImageOutputModel = /** @class */ (function () {
    function FEItemImageOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEItemImageOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEItemImageOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEItemImageOutputModel();
        result.init(data);
        return result;
    };
    FEItemImageOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEItemImageOutputModel;
}());
exports.FEItemImageOutputModel = FEItemImageOutputModel;
var FEItemOutputModel = /** @class */ (function () {
    function FEItemOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEItemOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.status = _data["status"];
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.itemOption = _data["itemOption"];
            this.variationOptionDisplayText = _data["variationOptionDisplayText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionDisplayText"]) : undefined;
            this.variationOptionLabelText = _data["variationOptionLabelText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionLabelText"]) : undefined;
            this.variationOptionHintText = _data["variationOptionHintText"] ? LocalizedStringOutputModel.fromJS(_data["variationOptionHintText"]) : undefined;
            this.description = _data["description"] ? LocalizedStringOutputModel.fromJS(_data["description"]) : undefined;
            this.shortDescription = _data["shortDescription"] ? LocalizedStringOutputModel.fromJS(_data["shortDescription"]) : undefined;
            this.cost = _data["cost"];
            this.paidAmount = _data["paidAmount"];
            this.fixedDonationAmount = _data["fixedDonationAmount"];
            this.defaultUserInputAmount = _data["defaultUserInputAmount"];
            this.type = _data["type"];
            this.paymentType = _data["paymentType"];
            this.isVariant = _data["isVariant"];
            this.hasVariations = _data["hasVariations"];
            this.hideAddToCartButton = _data["hideAddToCartButton"];
            this.showAgreeToTermsOption = _data["showAgreeToTermsOption"];
            this.agreeToTermsMessage = _data["agreeToTermsMessage"];
            if (Array.isArray(_data["variations"])) {
                this.variations = [];
                for (var _i = 0, _a = _data["variations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.variations.push(FEItemOutputModel.fromJS(item));
                }
            }
            this.displaySuggestedAmounts = _data["displaySuggestedAmounts"];
            if (Array.isArray(_data["suggestedAmounts"])) {
                this.suggestedAmounts = [];
                for (var _b = 0, _c = _data["suggestedAmounts"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.suggestedAmounts.push(FESuggestedAmountOutputModel.fromJS(item));
                }
            }
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (var _d = 0, _e = _data["images"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.images.push(FEItemImageOutputModel.fromJS(item));
                }
            }
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.barcode = _data["barcode"];
            this.outlineId = _data["outlineId"];
            this.outline = _data["outline"];
            this.mainThumbnailUrl = _data["mainThumbnailUrl"];
            this.paymentProgress = _data["paymentProgress"];
            this.isCommingSoon = _data["isCommingSoon"];
            this.commingSoonText = _data["commingSoonText"] ? LocalizedStringOutputModel.fromJS(_data["commingSoonText"]) : undefined;
            this.maxNumberOfSubscriptionShares = _data["maxNumberOfSubscriptionShares"];
            this.currentNumberOfSubscriptionShares = _data["currentNumberOfSubscriptionShares"];
            this.shareCost = _data["shareCost"];
            this.shouldNavigateToUrl = _data["shouldNavigateToUrl"];
            this.navigateToUrl = _data["navigateToUrl"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEItemOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEItemOutputModel();
        result.init(data);
        return result;
    };
    FEItemOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["itemOption"] = this.itemOption;
        data["variationOptionDisplayText"] = this.variationOptionDisplayText ? this.variationOptionDisplayText.toJSON() : undefined;
        data["variationOptionLabelText"] = this.variationOptionLabelText ? this.variationOptionLabelText.toJSON() : undefined;
        data["variationOptionHintText"] = this.variationOptionHintText ? this.variationOptionHintText.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined;
        data["cost"] = this.cost;
        data["paidAmount"] = this.paidAmount;
        data["fixedDonationAmount"] = this.fixedDonationAmount;
        data["defaultUserInputAmount"] = this.defaultUserInputAmount;
        data["type"] = this.type;
        data["paymentType"] = this.paymentType;
        data["isVariant"] = this.isVariant;
        data["hasVariations"] = this.hasVariations;
        data["hideAddToCartButton"] = this.hideAddToCartButton;
        data["showAgreeToTermsOption"] = this.showAgreeToTermsOption;
        data["agreeToTermsMessage"] = this.agreeToTermsMessage;
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (var _i = 0, _a = this.variations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["variations"].push(item ? item.toJSON() : undefined);
            }
        }
        data["displaySuggestedAmounts"] = this.displaySuggestedAmounts;
        if (Array.isArray(this.suggestedAmounts)) {
            data["suggestedAmounts"] = [];
            for (var _b = 0, _c = this.suggestedAmounts; _b < _c.length; _b++) {
                var item = _c[_b];
                data["suggestedAmounts"].push(item ? item.toJSON() : undefined);
            }
        }
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (var _d = 0, _e = this.images; _d < _e.length; _d++) {
                var item = _e[_d];
                data["images"].push(item ? item.toJSON() : undefined);
            }
        }
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["barcode"] = this.barcode;
        data["outlineId"] = this.outlineId;
        data["outline"] = this.outline;
        data["mainThumbnailUrl"] = this.mainThumbnailUrl;
        data["paymentProgress"] = this.paymentProgress;
        data["isCommingSoon"] = this.isCommingSoon;
        data["commingSoonText"] = this.commingSoonText ? this.commingSoonText.toJSON() : undefined;
        data["maxNumberOfSubscriptionShares"] = this.maxNumberOfSubscriptionShares;
        data["currentNumberOfSubscriptionShares"] = this.currentNumberOfSubscriptionShares;
        data["shareCost"] = this.shareCost;
        data["shouldNavigateToUrl"] = this.shouldNavigateToUrl;
        data["navigateToUrl"] = this.navigateToUrl;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEItemOutputModel;
}());
exports.FEItemOutputModel = FEItemOutputModel;
var PagedMetadata = /** @class */ (function () {
    function PagedMetadata(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedMetadata.prototype.init = function (_data) {
        if (_data) {
            this.totalItemCount = _data["totalItemCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.numberOfPages = _data["numberOfPages"];
            this.hasNextPage = _data["hasNextPage"];
        }
    };
    PagedMetadata.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedMetadata();
        result.init(data);
        return result;
    };
    PagedMetadata.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalItemCount"] = this.totalItemCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["numberOfPages"] = this.numberOfPages;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    };
    return PagedMetadata;
}());
exports.PagedMetadata = PagedMetadata;
var FEPagedItemsOutputModel = /** @class */ (function () {
    function FEPagedItemsOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEPagedItemsOutputModel.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (var _i = 0, _a = _data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FEItemOutputModel.fromJS(item));
                }
            }
            this.metadata = _data["metadata"] ? PagedMetadata.fromJS(_data["metadata"]) : undefined;
        }
    };
    FEPagedItemsOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEPagedItemsOutputModel();
        result.init(data);
        return result;
    };
    FEPagedItemsOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item ? item.toJSON() : undefined);
            }
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : undefined;
        return data;
    };
    return FEPagedItemsOutputModel;
}());
exports.FEPagedItemsOutputModel = FEPagedItemsOutputModel;
var BannerItemDestinationType;
(function (BannerItemDestinationType) {
    BannerItemDestinationType["None"] = "None";
    BannerItemDestinationType["Item"] = "Item";
    BannerItemDestinationType["Category"] = "Category";
    BannerItemDestinationType["Url"] = "Url";
})(BannerItemDestinationType = exports.BannerItemDestinationType || (exports.BannerItemDestinationType = {}));
var FEBannerItemOutputModel = /** @class */ (function () {
    function FEBannerItemOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEBannerItemOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.imageUrl = _data["imageUrl"] ? LocalizedStringOutputModel.fromJS(_data["imageUrl"]) : undefined;
            this.sortOrder = _data["sortOrder"];
            this.destinationType = _data["destinationType"];
            this.destinationOutlineId = _data["destinationOutlineId"];
            this.destinationName = _data["destinationName"];
            this.url = _data["url"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEBannerItemOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEBannerItemOutputModel();
        result.init(data);
        return result;
    };
    FEBannerItemOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl ? this.imageUrl.toJSON() : undefined;
        data["sortOrder"] = this.sortOrder;
        data["destinationType"] = this.destinationType;
        data["destinationOutlineId"] = this.destinationOutlineId;
        data["destinationName"] = this.destinationName;
        data["url"] = this.url;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEBannerItemOutputModel;
}());
exports.FEBannerItemOutputModel = FEBannerItemOutputModel;
var FEBannerOutputModel = /** @class */ (function () {
    function FEBannerOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEBannerOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.bannerPosition = _data["bannerPosition"];
            this.title = _data["title"] ? LocalizedStringOutputModel.fromJS(_data["title"]) : undefined;
            this.description = _data["description"] ? LocalizedStringOutputModel.fromJS(_data["description"]) : undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["bannarItems"])) {
                this.bannarItems = [];
                for (var _i = 0, _a = _data["bannarItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.bannarItems.push(FEBannerItemOutputModel.fromJS(item));
                }
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEBannerOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEBannerOutputModel();
        result.init(data);
        return result;
    };
    FEBannerOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["bannerPosition"] = this.bannerPosition;
        data["title"] = this.title ? this.title.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.bannarItems)) {
            data["bannarItems"] = [];
            for (var _i = 0, _a = this.bannarItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["bannarItems"].push(item ? item.toJSON() : undefined);
            }
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEBannerOutputModel;
}());
exports.FEBannerOutputModel = FEBannerOutputModel;
var HelpRequestFormFieldType;
(function (HelpRequestFormFieldType) {
    HelpRequestFormFieldType["TextField"] = "TextField";
    HelpRequestFormFieldType["TextArea"] = "TextArea";
    HelpRequestFormFieldType["Radio"] = "Radio";
    HelpRequestFormFieldType["Dropdown"] = "Dropdown";
    HelpRequestFormFieldType["ImageUpload"] = "ImageUpload";
    HelpRequestFormFieldType["Undefined"] = "Undefined";
})(HelpRequestFormFieldType = exports.HelpRequestFormFieldType || (exports.HelpRequestFormFieldType = {}));
var FEHelpRequestFormFieldOptionOutputModel = /** @class */ (function () {
    function FEHelpRequestFormFieldOptionOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEHelpRequestFormFieldOptionOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEHelpRequestFormFieldOptionOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEHelpRequestFormFieldOptionOutputModel();
        result.init(data);
        return result;
    };
    FEHelpRequestFormFieldOptionOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEHelpRequestFormFieldOptionOutputModel;
}());
exports.FEHelpRequestFormFieldOptionOutputModel = FEHelpRequestFormFieldOptionOutputModel;
var FEHelpRequestFormFieldOutputModel = /** @class */ (function () {
    function FEHelpRequestFormFieldOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEHelpRequestFormFieldOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.hint = _data["hint"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.showBasedOnSelectedOption = _data["showBasedOnSelectedOption"];
            this.showForOptionId = _data["showForOptionId"];
            this.showForOptionFieldId = _data["showForOptionFieldId"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["options"])) {
                this.options = [];
                for (var _i = 0, _a = _data["options"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.options.push(FEHelpRequestFormFieldOptionOutputModel.fromJS(item));
                }
            }
            this.sortOrder = _data["sortOrder"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEHelpRequestFormFieldOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEHelpRequestFormFieldOutputModel();
        result.init(data);
        return result;
    };
    FEHelpRequestFormFieldOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["hint"] = this.hint;
        data["description"] = this.description;
        data["type"] = this.type;
        data["showBasedOnSelectedOption"] = this.showBasedOnSelectedOption;
        data["showForOptionId"] = this.showForOptionId;
        data["showForOptionFieldId"] = this.showForOptionFieldId;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (var _i = 0, _a = this.options; _i < _a.length; _i++) {
                var item = _a[_i];
                data["options"].push(item ? item.toJSON() : undefined);
            }
        }
        data["sortOrder"] = this.sortOrder;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEHelpRequestFormFieldOutputModel;
}());
exports.FEHelpRequestFormFieldOutputModel = FEHelpRequestFormFieldOutputModel;
var FEHelpRequestFormOutputModel = /** @class */ (function () {
    function FEHelpRequestFormOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEHelpRequestFormOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                for (var _i = 0, _a = _data["fields"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.fields.push(FEHelpRequestFormFieldOutputModel.fromJS(item));
                }
            }
            this.sortOrder = _data["sortOrder"];
            this.maximumNumberRequests = _data["maximumNumberRequests"];
            this.trackNumberOfRequests = _data["trackNumberOfRequests"];
            this.isClosed = _data["isClosed"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEHelpRequestFormOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEHelpRequestFormOutputModel();
        result.init(data);
        return result;
    };
    FEHelpRequestFormOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (var _i = 0, _a = this.fields; _i < _a.length; _i++) {
                var item = _a[_i];
                data["fields"].push(item ? item.toJSON() : undefined);
            }
        }
        data["sortOrder"] = this.sortOrder;
        data["maximumNumberRequests"] = this.maximumNumberRequests;
        data["trackNumberOfRequests"] = this.trackNumberOfRequests;
        data["isClosed"] = this.isClosed;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEHelpRequestFormOutputModel;
}());
exports.FEHelpRequestFormOutputModel = FEHelpRequestFormOutputModel;
var DedicationDesignOutputModel = /** @class */ (function () {
    function DedicationDesignOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DedicationDesignOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.imageUrl = _data["imageUrl"];
            this.pdfUrl = _data["pdfUrl"];
            this.fromColor = _data["fromColor"];
            this.toColor = _data["toColor"];
            this.messageColor = _data["messageColor"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    DedicationDesignOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DedicationDesignOutputModel();
        result.init(data);
        return result;
    };
    DedicationDesignOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["imageUrl"] = this.imageUrl;
        data["pdfUrl"] = this.pdfUrl;
        data["fromColor"] = this.fromColor;
        data["toColor"] = this.toColor;
        data["messageColor"] = this.messageColor;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return DedicationDesignOutputModel;
}());
exports.DedicationDesignOutputModel = DedicationDesignOutputModel;
var HelpRequestFieldInputModel = /** @class */ (function () {
    function HelpRequestFieldInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HelpRequestFieldInputModel.prototype.init = function (_data) {
        if (_data) {
            this.text = _data["text"];
            this.selectedOptionId = _data["selectedOptionId"];
            this.imageName = _data["imageName"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    };
    HelpRequestFieldInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HelpRequestFieldInputModel();
        result.init(data);
        return result;
    };
    HelpRequestFieldInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["selectedOptionId"] = this.selectedOptionId;
        data["imageName"] = this.imageName;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    };
    return HelpRequestFieldInputModel;
}());
exports.HelpRequestFieldInputModel = HelpRequestFieldInputModel;
var HelpRequestInputModel = /** @class */ (function () {
    function HelpRequestInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HelpRequestInputModel.prototype.init = function (_data) {
        if (_data) {
            this.formId = _data["formId"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                for (var _i = 0, _a = _data["fields"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.fields.push(HelpRequestFieldInputModel.fromJS(item));
                }
            }
            this.key = _data["key"];
        }
    };
    HelpRequestInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HelpRequestInputModel();
        result.init(data);
        return result;
    };
    HelpRequestInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (var _i = 0, _a = this.fields; _i < _a.length; _i++) {
                var item = _a[_i];
                data["fields"].push(item ? item.toJSON() : undefined);
            }
        }
        data["key"] = this.key;
        return data;
    };
    return HelpRequestInputModel;
}());
exports.HelpRequestInputModel = HelpRequestInputModel;
var UploadedImageFileOutputModel = /** @class */ (function () {
    function UploadedImageFileOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadedImageFileOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.fileName = _data["fileName"];
        }
    };
    UploadedImageFileOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadedImageFileOutputModel();
        result.init(data);
        return result;
    };
    UploadedImageFileOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        return data;
    };
    return UploadedImageFileOutputModel;
}());
exports.UploadedImageFileOutputModel = UploadedImageFileOutputModel;
var FEOrderSummaryOutputModel = /** @class */ (function () {
    function FEOrderSummaryOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEOrderSummaryOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.total = _data["total"];
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            this.number = _data["number"];
            this.postDate = _data["postDate"];
            this.completedDate = _data["completedDate"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEOrderSummaryOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEOrderSummaryOutputModel();
        result.init(data);
        return result;
    };
    FEOrderSummaryOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        data["number"] = this.number;
        data["postDate"] = this.postDate;
        data["completedDate"] = this.completedDate;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEOrderSummaryOutputModel;
}());
exports.FEOrderSummaryOutputModel = FEOrderSummaryOutputModel;
var ExternnalPaymentUrlOutputModel = /** @class */ (function () {
    function ExternnalPaymentUrlOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternnalPaymentUrlOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.orderId = _data["orderId"];
        }
    };
    ExternnalPaymentUrlOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternnalPaymentUrlOutputModel();
        result.init(data);
        return result;
    };
    ExternnalPaymentUrlOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["orderId"] = this.orderId;
        return data;
    };
    return ExternnalPaymentUrlOutputModel;
}());
exports.ExternnalPaymentUrlOutputModel = ExternnalPaymentUrlOutputModel;
var DedicationInfoInputModel = /** @class */ (function () {
    function DedicationInfoInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DedicationInfoInputModel.prototype.init = function (_data) {
        if (_data) {
            this.hasDedication = _data["hasDedication"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.dedicationDesignId = _data["dedicationDesignId"];
        }
    };
    DedicationInfoInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DedicationInfoInputModel();
        result.init(data);
        return result;
    };
    DedicationInfoInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["hasDedication"] = this.hasDedication;
        data["from"] = this.from;
        data["to"] = this.to;
        data["dedicationDesignId"] = this.dedicationDesignId;
        return data;
    };
    return DedicationInfoInputModel;
}());
exports.DedicationInfoInputModel = DedicationInfoInputModel;
var OrderPaymentMethod = /** @class */ (function () {
    function OrderPaymentMethod(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderPaymentMethod.prototype.init = function (_data) {
        if (_data) {
            this.englishName = _data["englishName"];
            this.arabicName = _data["arabicName"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.info = _data["info"];
        }
    };
    OrderPaymentMethod.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderPaymentMethod();
        result.init(data);
        return result;
    };
    OrderPaymentMethod.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["englishName"] = this.englishName;
        data["arabicName"] = this.arabicName;
        data["paymentMethodId"] = this.paymentMethodId;
        data["info"] = this.info;
        return data;
    };
    return OrderPaymentMethod;
}());
exports.OrderPaymentMethod = OrderPaymentMethod;
var FEOrderLineItemOutputModel = /** @class */ (function () {
    function FEOrderLineItemOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEOrderLineItemOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.originalItemId = _data["originalItemId"];
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.barcode = _data["barcode"];
            this.type = _data["type"];
            this.paymentType = _data["paymentType"];
            this.fixedDonationAmount = _data["fixedDonationAmount"];
            this.quantity = _data["quantity"];
            this.paidAmount = _data["paidAmount"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEOrderLineItemOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEOrderLineItemOutputModel();
        result.init(data);
        return result;
    };
    FEOrderLineItemOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["originalItemId"] = this.originalItemId;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["barcode"] = this.barcode;
        data["type"] = this.type;
        data["paymentType"] = this.paymentType;
        data["fixedDonationAmount"] = this.fixedDonationAmount;
        data["quantity"] = this.quantity;
        data["paidAmount"] = this.paidAmount;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEOrderLineItemOutputModel;
}());
exports.FEOrderLineItemOutputModel = FEOrderLineItemOutputModel;
var DedicationInfo = /** @class */ (function () {
    function DedicationInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DedicationInfo.prototype.init = function (_data) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            this.message = _data["message"];
            this.dedicationDesignId = _data["dedicationDesignId"];
            this.imageUrl = _data["imageUrl"];
            this.pdfUrl = _data["pdfUrl"];
            this.fromColor = _data["fromColor"];
            this.toColor = _data["toColor"];
            this.messageColor = _data["messageColor"];
            this.dedicationCardUrl = _data["dedicationCardUrl"];
        }
    };
    DedicationInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DedicationInfo();
        result.init(data);
        return result;
    };
    DedicationInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        data["message"] = this.message;
        data["dedicationDesignId"] = this.dedicationDesignId;
        data["imageUrl"] = this.imageUrl;
        data["pdfUrl"] = this.pdfUrl;
        data["fromColor"] = this.fromColor;
        data["toColor"] = this.toColor;
        data["messageColor"] = this.messageColor;
        data["dedicationCardUrl"] = this.dedicationCardUrl;
        return data;
    };
    return DedicationInfo;
}());
exports.DedicationInfo = DedicationInfo;
var FEOrderOutputModel = /** @class */ (function () {
    function FEOrderOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEOrderOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.total = _data["total"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined;
            this.paymentMethod = _data["paymentMethod"] ? OrderPaymentMethod.fromJS(_data["paymentMethod"]) : undefined;
            this.completedAt = _data["completedAt"];
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [];
                for (var _i = 0, _a = _data["lineItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.lineItems.push(FEOrderLineItemOutputModel.fromJS(item));
                }
            }
            this.trackID = _data["trackID"];
            this.number = _data["number"];
            this.refrenceID = _data["refrenceID"];
            this.paymentInfo = _data["paymentInfo"];
            this.dedicationInfo = _data["dedicationInfo"] ? DedicationInfo.fromJS(_data["dedicationInfo"]) : undefined;
            this.hasDedication = _data["hasDedication"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEOrderOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEOrderOutputModel();
        result.init(data);
        return result;
    };
    FEOrderOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : undefined;
        data["completedAt"] = this.completedAt;
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (var _i = 0, _a = this.lineItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["lineItems"].push(item ? item.toJSON() : undefined);
            }
        }
        data["trackID"] = this.trackID;
        data["number"] = this.number;
        data["refrenceID"] = this.refrenceID;
        data["paymentInfo"] = this.paymentInfo;
        data["dedicationInfo"] = this.dedicationInfo ? this.dedicationInfo.toJSON() : undefined;
        data["hasDedication"] = this.hasDedication;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEOrderOutputModel;
}());
exports.FEOrderOutputModel = FEOrderOutputModel;
var FESubscriptionInvoiceSummaryOutputModel = /** @class */ (function () {
    function FESubscriptionInvoiceSummaryOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESubscriptionInvoiceSummaryOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.total = _data["total"];
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            this.number = _data["number"];
            this.postDate = _data["postDate"];
            this.completedDate = _data["completedDate"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FESubscriptionInvoiceSummaryOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESubscriptionInvoiceSummaryOutputModel();
        result.init(data);
        return result;
    };
    FESubscriptionInvoiceSummaryOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        data["number"] = this.number;
        data["postDate"] = this.postDate;
        data["completedDate"] = this.completedDate;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FESubscriptionInvoiceSummaryOutputModel;
}());
exports.FESubscriptionInvoiceSummaryOutputModel = FESubscriptionInvoiceSummaryOutputModel;
var CreateInvoiceInputModel = /** @class */ (function () {
    function CreateInvoiceInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateInvoiceInputModel.prototype.init = function (_data) {
        if (_data) {
            if (Array.isArray(_data["subscriptionInstallmentIds"])) {
                this.subscriptionInstallmentIds = [];
                for (var _i = 0, _a = _data["subscriptionInstallmentIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.subscriptionInstallmentIds.push(item);
                }
            }
        }
    };
    CreateInvoiceInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateInvoiceInputModel();
        result.init(data);
        return result;
    };
    CreateInvoiceInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscriptionInstallmentIds)) {
            data["subscriptionInstallmentIds"] = [];
            for (var _i = 0, _a = this.subscriptionInstallmentIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["subscriptionInstallmentIds"].push(item);
            }
        }
        return data;
    };
    return CreateInvoiceInputModel;
}());
exports.CreateInvoiceInputModel = CreateInvoiceInputModel;
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Undefined"] = "Undefined";
    SubscriptionStatus["Active"] = "Active";
    SubscriptionStatus["Canceled"] = "Canceled";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var FESubscriptionInstallmentOutputModel = /** @class */ (function () {
    function FESubscriptionInstallmentOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESubscriptionInstallmentOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.installmentDate = _data["installmentDate"] ? new Date(_data["installmentDate"].toString()) : undefined;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : undefined;
            this.isPaid = _data["isPaid"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FESubscriptionInstallmentOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESubscriptionInstallmentOutputModel();
        result.init(data);
        return result;
    };
    FESubscriptionInstallmentOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["installmentDate"] = this.installmentDate ? this.installmentDate.toISOString() : undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined;
        data["isPaid"] = this.isPaid;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FESubscriptionInstallmentOutputModel;
}());
exports.FESubscriptionInstallmentOutputModel = FESubscriptionInstallmentOutputModel;
var FESubscriptionOutputModel = /** @class */ (function () {
    function FESubscriptionOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESubscriptionOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"] ? LocalizedStringOutputModel.fromJS(_data["name"]) : undefined;
            this.originalItemId = _data["originalItemId"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.shareCost = _data["shareCost"];
            this.numberOfShares = _data["numberOfShares"];
            this.balance = _data["balance"];
            this.nextBillingDate = _data["nextBillingDate"] ? new Date(_data["nextBillingDate"].toString()) : undefined;
            this.nextBillingDateString = _data["nextBillingDateString"];
            this.numberOfUnpaidInstallments = _data["numberOfUnpaidInstallments"];
            if (Array.isArray(_data["installments"])) {
                this.installments = [];
                for (var _i = 0, _a = _data["installments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.installments.push(FESubscriptionInstallmentOutputModel.fromJS(item));
                }
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FESubscriptionOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESubscriptionOutputModel();
        result.init(data);
        return result;
    };
    FESubscriptionOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["originalItemId"] = this.originalItemId;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["shareCost"] = this.shareCost;
        data["numberOfShares"] = this.numberOfShares;
        data["balance"] = this.balance;
        data["nextBillingDate"] = this.nextBillingDate ? this.nextBillingDate.toISOString() : undefined;
        data["nextBillingDateString"] = this.nextBillingDateString;
        data["numberOfUnpaidInstallments"] = this.numberOfUnpaidInstallments;
        if (Array.isArray(this.installments)) {
            data["installments"] = [];
            for (var _i = 0, _a = this.installments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["installments"].push(item ? item.toJSON() : undefined);
            }
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FESubscriptionOutputModel;
}());
exports.FESubscriptionOutputModel = FESubscriptionOutputModel;
var FESubscriptionLookupOutputModel = /** @class */ (function () {
    function FESubscriptionLookupOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESubscriptionLookupOutputModel.prototype.init = function (_data) {
        if (_data) {
            if (_data["subscriptionItemsLookup"]) {
                this.subscriptionItemsLookup = {};
                for (var key in _data["subscriptionItemsLookup"]) {
                    if (_data["subscriptionItemsLookup"].hasOwnProperty(key))
                        this.subscriptionItemsLookup[key] = _data["subscriptionItemsLookup"][key];
                }
            }
        }
    };
    FESubscriptionLookupOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESubscriptionLookupOutputModel();
        result.init(data);
        return result;
    };
    FESubscriptionLookupOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.subscriptionItemsLookup) {
            data["subscriptionItemsLookup"] = {};
            for (var key in this.subscriptionItemsLookup) {
                if (this.subscriptionItemsLookup.hasOwnProperty(key))
                    data["subscriptionItemsLookup"][key] = this.subscriptionItemsLookup[key];
            }
        }
        return data;
    };
    return FESubscriptionLookupOutputModel;
}());
exports.FESubscriptionLookupOutputModel = FESubscriptionLookupOutputModel;
var SubscribeToItemInputModel = /** @class */ (function () {
    function SubscribeToItemInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscribeToItemInputModel.prototype.init = function (_data) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.amount = _data["amount"];
        }
    };
    SubscribeToItemInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscribeToItemInputModel();
        result.init(data);
        return result;
    };
    SubscribeToItemInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["amount"] = this.amount;
        return data;
    };
    return SubscribeToItemInputModel;
}());
exports.SubscribeToItemInputModel = SubscribeToItemInputModel;
var UpdateSubscriptionInputModel = /** @class */ (function () {
    function UpdateSubscriptionInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateSubscriptionInputModel.prototype.init = function (_data) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.status = _data["status"];
            this.amount = _data["amount"];
        }
    };
    UpdateSubscriptionInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateSubscriptionInputModel();
        result.init(data);
        return result;
    };
    UpdateSubscriptionInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["status"] = this.status;
        data["amount"] = this.amount;
        return data;
    };
    return UpdateSubscriptionInputModel;
}());
exports.UpdateSubscriptionInputModel = UpdateSubscriptionInputModel;
var FESubscriptionInvoiceInstallmentOutputModel = /** @class */ (function () {
    function FESubscriptionInvoiceInstallmentOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESubscriptionInvoiceInstallmentOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.installmentDate = _data["installmentDate"] ? new Date(_data["installmentDate"].toString()) : undefined;
            this.subscription = _data["subscription"] ? FESubscriptionOutputModel.fromJS(_data["subscription"]) : undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FESubscriptionInvoiceInstallmentOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESubscriptionInvoiceInstallmentOutputModel();
        result.init(data);
        return result;
    };
    FESubscriptionInvoiceInstallmentOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["installmentDate"] = this.installmentDate ? this.installmentDate.toISOString() : undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FESubscriptionInvoiceInstallmentOutputModel;
}());
exports.FESubscriptionInvoiceInstallmentOutputModel = FESubscriptionInvoiceInstallmentOutputModel;
var FESubscriptionInvoiceOutputModel = /** @class */ (function () {
    function FESubscriptionInvoiceOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FESubscriptionInvoiceOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.isConfirmed = _data["isConfirmed"];
            this.customerId = _data["customerId"];
            this.total = _data["total"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined;
            this.paymentMethod = _data["paymentMethod"] ? OrderPaymentMethod.fromJS(_data["paymentMethod"]) : undefined;
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            if (Array.isArray(_data["installments"])) {
                this.installments = [];
                for (var _i = 0, _a = _data["installments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.installments.push(FESubscriptionInvoiceInstallmentOutputModel.fromJS(item));
                }
            }
            this.trackID = _data["trackID"];
            this.number = _data["number"];
            this.refrenceID = _data["refrenceID"];
            this.paymentInfo = _data["paymentInfo"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FESubscriptionInvoiceOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FESubscriptionInvoiceOutputModel();
        result.init(data);
        return result;
    };
    FESubscriptionInvoiceOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isConfirmed"] = this.isConfirmed;
        data["customerId"] = this.customerId;
        data["total"] = this.total;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : undefined;
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        if (Array.isArray(this.installments)) {
            data["installments"] = [];
            for (var _i = 0, _a = this.installments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["installments"].push(item ? item.toJSON() : undefined);
            }
        }
        data["trackID"] = this.trackID;
        data["number"] = this.number;
        data["refrenceID"] = this.refrenceID;
        data["paymentInfo"] = this.paymentInfo;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FESubscriptionInvoiceOutputModel;
}());
exports.FESubscriptionInvoiceOutputModel = FESubscriptionInvoiceOutputModel;
var FEUnpaidSubscriptionInstallmentOutputModel = /** @class */ (function () {
    function FEUnpaidSubscriptionInstallmentOutputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FEUnpaidSubscriptionInstallmentOutputModel.prototype.init = function (_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.installmentDate = _data["installmentDate"] ? new Date(_data["installmentDate"].toString()) : undefined;
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionName = _data["subscriptionName"] ? LocalizedStringOutputModel.fromJS(_data["subscriptionName"]) : undefined;
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
        }
    };
    FEUnpaidSubscriptionInstallmentOutputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FEUnpaidSubscriptionInstallmentOutputModel();
        result.init(data);
        return result;
    };
    FEUnpaidSubscriptionInstallmentOutputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["installmentDate"] = this.installmentDate ? this.installmentDate.toISOString() : undefined;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionName"] = this.subscriptionName ? this.subscriptionName.toJSON() : undefined;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        return data;
    };
    return FEUnpaidSubscriptionInstallmentOutputModel;
}());
exports.FEUnpaidSubscriptionInstallmentOutputModel = FEUnpaidSubscriptionInstallmentOutputModel;
var AddMultipleInstallmentsInputModel = /** @class */ (function () {
    function AddMultipleInstallmentsInputModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddMultipleInstallmentsInputModel.prototype.init = function (_data) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.numberOfInstallments = _data["numberOfInstallments"];
        }
    };
    AddMultipleInstallmentsInputModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddMultipleInstallmentsInputModel();
        result.init(data);
        return result;
    };
    AddMultipleInstallmentsInputModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["numberOfInstallments"] = this.numberOfInstallments;
        return data;
    };
    return AddMultipleInstallmentsInputModel;
}());
exports.AddMultipleInstallmentsInputModel = AddMultipleInstallmentsInputModel;
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
